import {
    Navigate,
    Outlet,
} from "react-router-dom";

import {
    useSelector,
} from "react-redux";

import type {
    RootState,
} from "../store";

import { getRouteForPhase } from "../utils/journeyRouting";


const PublicRoute = () => {

    const token =
        useSelector(
            (state: RootState) =>
                state.auth.token
        );

    const journey =
        useSelector(
            (state: RootState) =>
                state.journey.journey
        );


    /*
     * Already authenticated.
     *
     * Do not allow the customer to go back
     * to Login or OTP — but route them to
     * wherever their journey phase says they
     * should be, not always the dashboard.
     */
    if (token) {

        const target = journey
            ? getRouteForPhase(journey.phase)
            : "/ndashboard";

        return (
            <Navigate
                to={target}
                replace
            />
        );
    }


    return <Outlet />;
};


export default PublicRoute;